import Cookies from 'js-cookie'
const schoolCode = 'school-Code'//学校识别码
const TokenKey = 'Admin-Token'
const UuidKey = 'Uu-id'
const schoolIdKey = 'school-Id'//学校id
const roleIdKey = 'role-Id'
const Nickname = 'Nick-Name'
const HeadPath = 'Head-Path'
const getuserPhonekey = 'User-Phone'
const getuserNamekey = 'User-Name'



export function getheadPath() {
  return Cookies.get(HeadPath)
}

export function setheadPath(headPath) {
  return Cookies.set(HeadPath, headPath)
}

export function removeheadPath() {
  return Cookies.remove(HeadPath)
}

export function getuserPhone() {
  return Cookies.get(getuserPhonekey)
}


export function setuserPhone(phone) {
  return Cookies.set(getuserPhonekey, phone)
}

export function removeuserPhone() {
  return Cookies.remove(getuserPhonekey)
}



export function getuserName() {
  return Cookies.get(getuserNamekey)
}


export function setuserName(username) {
  return Cookies.set(getuserNamekey, username)
}

export function removeuserName() {
  return Cookies.remove(getuserNamekey)
}





export function getschoolCode() {
  return Cookies.get(schoolCode)
}

export function setschoolCode(Code) {
  return Cookies.set(schoolCode, Code)
}

export function removeschoolCode() {
  return Cookies.remove(schoolCode)
}




export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUuid() {
  return Cookies.get(UuidKey)
}

export function setUuid(uuid) {
  return Cookies.set(UuidKey, uuid)
}

export function removeUuid() {
  return Cookies.remove(UuidKey)
}




export function getschoolId() {
  return Cookies.get(schoolIdKey)
}

export function setschoolId(schoolId) {
  return Cookies.set(schoolIdKey, schoolId)
}

export function removeschoolId() {
  return Cookies.remove(schoolIdKey)
}



export function getroleId() {
  return Cookies.get(roleIdKey)
}

export function setroleId(roleId) {
  return Cookies.set(roleIdKey, roleId)
}

export function removeroleId() {
  return Cookies.remove(roleIdKey)
}


export function getNickname() {
  return Cookies.get(Nickname)
}

export function setNickname(nickname) {
  return Cookies.set(Nickname, nickname)
}

export function removeNickname() {
  return Cookies.remove(Nickname)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js